import { supabase } from "../config/supabase";
import type { Database } from "../types/supabase";

// The owner and tracking dashboards' RPCs, through the anon client (3 s
// statement timeout). Names and arguments are declared in types/supabase.ts;
// each returns one jsonb document whose shape the caller types.

type Functions = Database["public"]["Functions"];

export type DashboardRpc =
  | "get_ops_health"
  | "get_ops_history"
  | "get_owner_analytics"
  | "get_owner_pricing"
  | "get_owner_records"
  | "get_owner_team"
  | "get_pricing_accuracy";

export type DashboardRpcArgs<N extends DashboardRpc> = Functions[N]["Args"];

/** Calls one dashboard RPC; `args` undefined sends none. */
export const callDashboardRpc = <N extends DashboardRpc>(name: N, args?: DashboardRpcArgs<N>) =>
  supabase.rpc(name, args);
